import { NgModule, CUSTOM_ELEMENTS_SCHEMA, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { NgxSpinnerModule } from "ngx-spinner";
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { EditOrderComponent } from './admin-container/edit-order/edit-order.component';
import { fakeBackendProvider } from './_helpers/fake-backend';
import { TrackInboundOrderComponent } from './admin-container/track-inbound-order/track-inbound-order.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { HomeComponent } from './home/home.component';
import { TrackOrderComponent } from './track-order/track-order.component';
import { TrackOutBoundOrdersComponent } from './admin-container/track-out-bound-orders/track-out-bound-orders.component';
import { TrackOutboundOrderComponent } from './track-outbound-order/track-outbound-order.component';
import { TrackReturnOrderComponent } from './track-return-order/track-return-order.component';
import { TrackingOutBoundOrderComponent } from './tracking-out-bound-order/tracking-out-bound-order.component';
import { DashboardComponent } from './admin-container/dashboard/dashboard.component';
import { SellerReportsDetailsComponent } from './admin-container/seller-reports-details/seller-reports-details.component';
import { InventoriesComponent } from './admin-container/inventories/inventories.component';
import { OrderProcessingComponent } from './admin-container/order-processing/order-processing.component';
import { InvoicesComponent } from './admin-container/invoices/invoices.component';
import { OrdersComponent } from './admin-container/orders/orders.component';
import { PaymentsComponent } from './admin-container/payments/payments.component';
import { LoginComponent } from './login-container/login/login.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { Registration1Component } from './login-container/registration1/registration1.component';
import { Otp2Component } from './login-container/otp2/otp2.component';
import { AuthenticateComponent } from './login-container/authenticate/authenticate.component';
import { AuthorizeComponent } from './login-container/authorize/authorize.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SellerOrdersListComponent } from './admin-container/seller-orders-list/seller-orders-list.component';
import { SellerDashboardComponent } from './admin-container/seller-dashboard/seller-dashboard.component';
import { ContactsComponent } from './admin-container/contacts/contacts.component';
import { InfoComponent } from './info/info.component';
import { ErrorComponent } from './error/error.component';
import { OtpComponent } from './login-container/otp/otp.component';
import { LoginContainerComponent } from './login-container/login-container.component';
import { Register } from './_models/register';
import { Caller } from './_models/caller';
import { RzrPmtRespComponent } from './login-container/rzr-pmt-resp/rzr-pmt-resp.component';
import { ForgotPasswordComponent } from './login-container/forgot-password/forgot-password.component';
import { AmznAuthComponent } from './login-container/amzn-auth/amzn-auth.component';
import { ZohoAuthComponent } from './login-container/zoho-auth/zoho-auth.component';
import { FlipkartAuthComponent } from './login-container/flipkart-auth/flipkart-auth.component';
import { ActivationComponent } from './login-container/activation/activation.component';
import { DunzoWebhookComponent } from './login-container/dunzo-webhook/dunzo-webhook.component';
import { ResetPasswordComponent } from './login-container/reset-password/reset-password.component';
import { PhonePipe } from './_pipes/phone.pipe';
import { ReplaceStatusPipe } from './_pipes/replace-status.pipe';
import { AdminContainerComponent } from './admin-container/admin-container.component';
import { AdminWalletPaymentComponent } from './admin-container/admin-wallet-payment/admin-wallet-payment.component';
import { WarehouseRequestListComponent } from './admin-container/warehouse-request-list/warehouse-request-list.component';
import { SecurityDefaultComponent } from './admin-container/security-default/security-default.component';
import { NotificationListComponent } from './admin-container/notification-list/notification-list.component';
import { EditNotificationComponent } from './admin-container/edit-notification/edit-notification.component';
import { CreateNotificationComponent } from './admin-container/create-notification/create-notification.component';
import { AccountOwnerSelectionComponent } from './admin-container/account-owner-selection/account-owner-selection.component';
import { AccountOwnerListComponent } from './admin-container/account-owner-list/account-owner-list.component';
import { CreateInventoryComponent } from './admin-container/create-inventory/create-inventory.component';
import { AddComponentComponent } from './admin-container/add-component/add-component.component';
import { DataTablesModule } from 'angular-datatables';
import { HomeListComponent } from './admin-container/home-list/home-list.component';
import { EditContactsComponent } from './admin-container/edit-contacts/edit-contacts.component';
import { EditInventoryComponent } from './admin-container/edit-inventory/edit-inventory.component';
import { CreateContactsComponent } from './admin-container/create-contacts/create-contacts.component';
import { ReportsComponent } from './admin-container/reports/reports.component';
import { ReturnsComponent } from './admin-container/returns/returns.component';
import { CreateOrdersComponent } from './admin-container/create-orders/create-orders.component';
import { SummaryOrdersComponent } from './admin-container/summary-orders/summary-orders.component';
import { AdminVerifyDocumentsComponent } from './admin-container/admin-verify-documents/admin-verify-documents.component';
import { EditAccountOwnerListComponent } from './admin-container/edit-account-owner-list/edit-account-owner-list.component';
import { AdminFulfillmentPricingComponent } from './admin-container/admin-fulfillment-pricing/admin-fulfillment-pricing.component';
import { AdminServicesPricingComponent } from './admin-container/admin-services-pricing/admin-services-pricing.component';
import { CreateAccountOwnerListComponent } from './admin-container/create-account-owner-list/create-account-owner-list.component';
import { WarehouseReceivingOrdersComponent } from './admin-container/warehouse-receiving-orders/warehouse-receiving-orders.component';
import { SettingReturnsComponent } from './admin-container/setting-returns/setting-returns.component';
import { CreateReturnsComponent } from './admin-container/create-returns/create-returns.component';
import { DeliveryChallanComponent } from './admin-container/delivery-challan/delivery-challan.component';
import { ShippingLabelComponent } from './admin-container/shipping-label/shipping-label.component';
import { ProcessingOrderComponent } from './admin-container/processing-order/processing-order.component';
import { ProcessingStockTransfersComponent } from './admin-container/processing-stock-transfers/processing-stock-transfers.component';
import { ViewOrdersComponent } from './admin-container/view-orders/view-orders.component';
import { ViewInvoicesComponent } from './admin-container/view-invoices/view-invoices.component';
import { MyAccountListComponent } from './admin-container/my-account-list/my-account-list.component';
import { MarketingComponent } from './admin-container/marketing/marketing.component';
import { TrackingPageMenuComponent } from './admin-container/tracking-page-menu/tracking-page-menu.component';
import { TrackingPageBannerComponent } from './admin-container/tracking-page-banner/tracking-page-banner.component';
import { SellerMarketingComponent } from './admin-container/seller-marketing/seller-marketing.component';
import { CreateInvoiceComponent } from './admin-container/create-invoice/create-invoice.component';
import { WarehouseViewComponent } from './admin-container/warehouse-view/warehouse-view.component';
import { InventoriesViewComponent } from './admin-container/inventories-view/inventories-view.component';
import { PaymentProcessingComponent } from './admin-container/payment-processing/payment-processing.component';
import { PaymentConfirmationComponent } from './admin-container/payment-confirmation/payment-confirmation.component';
import { PaymentStatusComponent } from './admin-container/payment-status/payment-status.component';
import { InvoiceSettingsComponent } from './admin-container/invoice-settings/invoice-settings.component';
import { UserAccountComponent } from './admin-container/user-account/user-account.component';
import { EditUserAccountComponent } from './admin-container/edit-user-account/edit-user-account.component';
import { AdminOrdersComponent } from './admin-container/admin-orders/admin-orders.component';
import { AdminShiftDeliveryCreateComponent } from './admin-container/admin-shift-delivery-create/admin-shift-delivery-create.component';
import { AdminShadowFaxCreateComponent } from './admin-container/admin-shadow-fax-create/admin-shadow-fax-create.component';
import { AdminBluedartCreateComponent } from './admin-container/admin-bluedart-create/admin-bluedart-create.component';
import { AdminDelhiveryCreateComponent } from './admin-container/admin-delhivery-create/admin-delhivery-create.component';
import { AdminDotzotCreateComponent } from './admin-container/admin-dotzot-create/admin-dotzot-create.component';
import { AdminGatiCreateComponent } from './admin-container/admin-gati-create/admin-gati-create.component';
import { AdminRapidDeliveryCreateComponent } from './admin-container/admin-rapid-delivery-create/admin-rapid-delivery-create.component';
import { AdminFedExCreateComponent } from './admin-container/admin-fed-ex-create/admin-fed-ex-create.component';
import { ShiftDeliveryCreateComponent } from './admin-container/shift-delivery-create/shift-delivery-create.component';
import { ShadowFaxCreateComponent } from './admin-container/shadow-fax-create/shadow-fax-create.component';
import { BlueDartCreateComponent } from './admin-container/blue-dart-create/blue-dart-create.component';
import { DelhiveryCreateComponent } from './admin-container/delhivery-create/delhivery-create.component';
import { DotzotCreateComponent } from './admin-container/dotzot-create/dotzot-create.component';
import { GatiCreateComponent } from './admin-container/gati-create/gati-create.component';
import { FinanceCODOrdersComponent } from './admin-container/finance-cod-orders/finance-cod-orders.component';
import { FinanceCodOrdersPaymentProcessingComponent } from './admin-container/finance-cod-orders-payment-processing/finance-cod-orders-payment-processing.component';
import { RapidDeliveryCreateComponent } from './admin-container/rapid-delivery-create/rapid-delivery-create.component';
import { FedExCreateComponent } from './admin-container/fed-ex-create/fed-ex-create.component';
import { AdminManageDelhiveryComponent } from './admin-container/admin-manage-delhivery/admin-manage-delhivery.component';
import { AdminManageFedexComponent } from './admin-container/admin-manage-fedex/admin-manage-fedex.component';
import { AdminManageDotzotComponent } from './admin-container/admin-manage-dotzot/admin-manage-dotzot.component';
import { AdminManageGatiComponent } from './admin-container/admin-manage-gati/admin-manage-gati.component';
import { AdminManageDunzoComponent } from './admin-container/admin-manage-dunzo/admin-manage-dunzo.component';
import { AdminManageWefastComponent } from './admin-container/admin-manage-wefast/admin-manage-wefast.component';
import { AdminManagePickrrComponent } from './admin-container/admin-manage-pickrr/admin-manage-pickrr.component';
import { AdminManageShippigoComponent } from './admin-container/admin-manage-shippigo/admin-manage-shippigo.component';
import { AdminManageShipyaariComponent } from './admin-container/admin-manage-shipyaari/admin-manage-shipyaari.component';
import { AdminManageVamashipComponent } from './admin-container/admin-manage-vamaship/admin-manage-vamaship.component';
import { DotzotManageComponent } from './admin-container/dotzot-manage/dotzot-manage.component';
import { CreateGoogleSheetComponent } from './admin-container/create-google-sheet/create-google-sheet.component';
import { GatiManageComponent } from './admin-container/gati-manage/gati-manage.component';
import { VamashipManageComponent } from './admin-container/vamaship-manage/vamaship-manage.component';
import { WefastManageComponent } from './admin-container/wefast-manage/wefast-manage.component';
import { PickrrManageComponent } from './admin-container/pickrr-manage/pickrr-manage.component';
import { ShipyaariManageComponent } from './admin-container/shipyaari-manage/shipyaari-manage.component';
import { ShippigoManageComponent } from './admin-container/shippigo-manage/shippigo-manage.component';
import { DelhiveryManageComponent } from './admin-container/delhivery-manage/delhivery-manage.component';
import { AdminConfigurationComponent } from './admin-container/admin-configuration/admin-configuration.component';
import { CODOrdersComponent } from './admin-container/cod-orders/cod-orders.component';
//import { HighchartsChartComponent } from 'highcharts-angular';
import { AdminInvoicesComponent } from './admin-container/admin-invoices/admin-invoices.component';
import { ShipmentCreateComponent } from './admin-container/shipment-create/shipment-create.component';
import { ShipmentListComponent } from './admin-container/shipment-list/shipment-list.component';
import { SettingsDriversComponent } from './admin-container/settings-drivers/settings-drivers.component';
import { AdminDashboardComponent } from './admin-container/admin-dashboard/admin-dashboard.component';
import { AdminShipmentListComponent } from './admin-container/admin-shipment-list/admin-shipment-list.component';
import { DriversListComponent } from './admin-container/drivers-list/drivers-list.component';
import { CreateDriverComponent } from './admin-container/create-driver/create-driver.component';
import { EditDriverComponent } from './admin-container/edit-driver/edit-driver.component';
import { CreateAddressComponent } from './admin-container/create-address/create-address.component';
import { EditAddressComponent } from './admin-container/edit-address/edit-address.component';
import { CreateAoSellerComponent } from './admin-container/create-ao-seller/create-ao-seller.component';
import { ViewAoSellerComponent } from './admin-container/view-ao-seller/view-ao-seller.component';
import { EditAoSellerComponent } from './admin-container/edit-ao-seller/edit-ao-seller.component';
import { ViewDriverComponent } from './admin-container/view-driver/view-driver.component';
import { StoreManagementComponent } from './admin-container/store-management/store-management.component';
import { ManageGoogleSheetComponent } from './admin-container/manage-google-sheet/manage-google-sheet.component';
import { DriverAssignmentComponent } from './admin-container/driver-assignment/driver-assignment.component';
import { DriverShipmentsComponent } from './admin-container/driver-shipments/driver-shipments.component';
import { DriverDashboardComponent } from './admin-container/driver-dashboard/driver-dashboard.component';
import { DriverMyAccountComponent } from './admin-container/driver-my-account/driver-my-account.component';
import { MagentoUserCreateComponent } from './admin-container/magento-user-create/magento-user-create.component';
import { ShopifyUserCreateComponent } from './admin-container/shopify-user-create/shopify-user-create.component';
import { AmazonUserCreateComponent } from './admin-container/amazon-user-create/amazon-user-create.component';
import { ShopcluesUserCreateComponent } from './admin-container/shopclues-user-create/shopclues-user-create.component';
import { BigCommerceUserCreateComponent } from './admin-container/big-commerce-user-create/big-commerce-user-create.component';
import { WoocommerceUserCreateComponent } from './admin-container/woocommerce-user-create/woocommerce-user-create.component';
import { PrestaShopUserCreateComponent } from './admin-container/presta-shop-user-create/presta-shop-user-create.component';
import { OpencartUserCreateComponent } from './admin-container/opencart-user-create/opencart-user-create.component';
import { FlipkartUserCreateComponent } from './admin-container/flipkart-user-create/flipkart-user-create.component';
import { EbayUserCreateComponent } from './admin-container/ebay-user-create/ebay-user-create.component';
import { ShipmentViewComponent } from './admin-container/shipment-view/shipment-view.component';
import { PrintLayoutComponent } from './admin-container/print-layout/print-layout.component';
import { PackageConfigurationComponent } from './admin-container/package-configuration/package-configuration.component';
import { AdminUserCreateComponent } from './admin-container/admin-user-create/admin-user-create.component';
import { QRCodeModule } from 'angularx-qrcode';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ToastrModule, ToastContainerModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OnlyNumbersDirective } from './_directives/only-numbers.directive';
//import { HighchartsChartModule } from 'highcharts-angular';
import { SecurityComponent } from './admin-container/security/security.component';
import { SecurityTypesComponent } from './admin-container/security-types/security-types.component';
import { AdminProductsComponent } from './admin-container/admin-products/admin-products.component';
import { CreateToteComponent } from './admin-container/create-tote/create-tote.component';
import { ToteListComponent } from './admin-container/tote-list/tote-list.component';
import { AdminUserListComponent } from './admin-container/admin-user-list/admin-user-list.component';
import { LoginPopupComponent } from './admin-container/login-popup/login-popup.component';
import { AdminRolesListComponent } from './admin-container/admin-roles-list/admin-roles-list.component';
import { CreateRoleComponent } from './admin-container/create-role/create-role.component';
import { NotificationSettingsComponent } from './admin-container/notification-settings/notification-settings.component';
import { StoreIntegrationsComponent } from './admin-container/store-integrations/store-integrations.component';
import { AdminStockTransferComponent } from './admin-container/admin-stock-transfer/admin-stock-transfer.component';
import { AdminSettingsComponent } from './admin-container/admin-settings/admin-settings.component';
import { ManageStoreManagementComponent } from './admin-container/manage-store-management/manage-store-management.component';
import { StoreConnectionsComponent } from './admin-container/store-connections/store-connections.component';
import { ShippingLabelSettingsComponent } from './admin-container/shipping-label-settings/shipping-label-settings.component';
import { EditRoleComponent } from './admin-container/edit-role/edit-role.component';
import { SupportContainerComponent } from './support-container/support-container.component';
import { DocumentSummaryComponent } from './support-container/document-summary/document-summary.component';
import { ReportsListComponent } from './admin-container/reports-list/reports-list.component';
import { ReportsDetailComponent } from './admin-container/reports-detail/reports-detail.component';
import { WarehouseSettingsDetailsComponent } from './admin-container/warehouse-settings-details/warehouse-settings-details.component';
import { ViewCustomerComponent } from './admin-container/view-customer/view-customer.component';
import { AdminReportsComponent } from './admin-container/admin-reports/admin-reports.component';
import { AdminReportsDetailComponent } from './admin-container/admin-reports-detail/admin-reports-detail.component';
import { ApiSettingsComponent } from './admin-container/api-settings/api-settings.component';
import { AdminReturnsComponent } from './admin-container/admin-returns/admin-returns.component';
import { ReturnOrderComponent } from './admin-container/return-order/return-order.component';
import { CreateReturnManuallyComponent } from './admin-container/create-return-manually/create-return-manually.component';
import { SplitOrderComponent } from './admin-container/split-order/split-order.component';
import { InvoiceCreateComponent } from './admin-container/invoice-create/invoice-create.component';
import { ClipboardModule } from 'ngx-clipboard';
import { ViewReturnOrderComponent } from './admin-container/view-return-order/view-return-order.component';
import { AdminCarriersComponent } from './admin-container/admin-carriers/admin-carriers.component';
import { AdminCarrierslistComponent } from './admin-container/admin-carrierslist/admin-carrierslist.component';
import { CustomerCarriersComponent } from './admin-container/customer-carriers/customer-carriers.component';
import { ShopifyManageStoreManagementComponent } from './admin-container/shopify-manage-store-management/shopify-manage-store-management.component';
import { CarriersListComponent } from './admin-container/carriers-list/carriers-list.component';
import { AmazonManageStoreManagementComponent } from './admin-container/amazon-manage-store-management/amazon-manage-store-management.component';
import { ShopcluesManageStoreManagementComponent } from './admin-container/shopclues-manage-store-management/shopclues-manage-store-management.component';
import { BigCommerceManageStoreManagementComponent } from './admin-container/big-commerce-manage-store-management/big-commerce-manage-store-management.component';
import { WoocommerceManageStoreManagementComponent } from './admin-container/woocommerce-manage-store-management/woocommerce-manage-store-management.component';
import { PrestaShopStoreManagementComponent } from './admin-container/presta-shop-store-management/presta-shop-store-management.component';
import { OpencartManageStoreManagementComponent } from './admin-container/opencart-manage-store-management/opencart-manage-store-management.component';
import { FlipkartManageStoreManagementComponent } from './admin-container/flipkart-manage-store-management/flipkart-manage-store-management.component';
import { EbayManageStoreManagementComponent } from './admin-container/ebay-manage-store-management/ebay-manage-store-management.component';
import { ViewAccountOwnerComponent } from './admin-container/view-account-owner/view-account-owner.component';
import { ScanQrCodeComponent } from './admin-container/scan-qr-code/scan-qr-code.component';
import { FormatsDialogComponent } from './admin-container/scan-code/formats-dialog/formats-dialog.component';
import { AppInfoDialogComponent } from './admin-container/scan-code/app-info-dialog/app-info-dialog.component';
import { AppInfoComponent } from './admin-container/scan-code/app-info/app-info.component';
import { SnapDealCreateComponent } from './admin-container/snap-deal-create/snap-deal-create.component';
import { SnapdealManageStoreManagementComponent } from './admin-container/snapdeal-manage-store-management/snapdeal-manage-store-management.component';
import { ZohoCommerceManageStoreManagementComponent } from './admin-container/zoho-commerce-manage-store-management/zoho-commerce-manage-store-management.component';
import { ZohoCommerceUserComponent } from './admin-container/zoho-commerce-user/zoho-commerce-user.component';
import { StoreHippoCreateComponent } from './admin-container/store-hippo-create/store-hippo-create.component';
import { ScheduledJobsConfigurationComponent } from './admin-container/scheduled-jobs-configuration/scheduled-jobs-configuration.component';
import { StoreHippoManageComponent } from './admin-container/store-hippo-manage/store-hippo-manage.component';
import { DunzoCreateComponent } from './admin-container/dunzo-create/dunzo-create.component';
import { ShiftDeliveryManageComponent } from './admin-container/shift-delivery-manage/shift-delivery-manage.component';
import { BlueDartManageComponent } from './admin-container/blue-dart-manage/blue-dart-manage.component';
import { ShadowFaxManageComponent } from './admin-container/shadow-fax-manage/shadow-fax-manage.component';
import { FedexManageComponent } from './admin-container/fedex-manage/fedex-manage.component';
import { DunzoManageComponent } from './admin-container/dunzo-manage/dunzo-manage.component';
import { AdminDunzoCreateComponent } from './admin-container/admin-dunzo-create/admin-dunzo-create.component';
import { AdminPickrrCreateComponent } from './admin-container/admin-pickrr-create/admin-pickrr-create.component';
import { AdminWeFastCreateComponent } from './admin-container/admin-we-fast-create/admin-we-fast-create.component';
import { AdminShipyaariCreateComponent } from './admin-container/admin-shipyaari-create/admin-shipyaari-create.component';
import { AdminShippigoCreateComponent } from './admin-container/admin-shippigo-create/admin-shippigo-create.component';
import { AdminVamashipCreateComponent } from './admin-container/admin-vamaship-create/admin-vamaship-create.component';
import { PickrrCreateComponent } from './admin-container/pickrr-create/pickrr-create.component';
import { WefastCreateComponent } from './admin-container/wefast-create/wefast-create.component';
import { ShippigoCreateComponent } from './admin-container/shippigo-create/shippigo-create.component';
import { ShipyaariCreateComponent } from './admin-container/shipyaari-create/shipyaari-create.component';
import { VamashipCreateComponent } from './admin-container/vamaship-create/vamaship-create.component';
import { AdminManageShiftDeliveryComponent } from './admin-container/admin-manage-shift-delivery/admin-manage-shift-delivery.component';
import { AdminManageShiftBlueDartComponent } from './admin-container/admin-manage-shift-blue-dart/admin-manage-shift-blue-dart.component';
import { AdminManageShadowFaxComponent } from './admin-container/admin-manage-shadow-fax/admin-manage-shadow-fax.component';
import { AdminUserViewComponent } from './admin-container/admin-user-view/admin-user-view.component';
import { AdminUserRoleEditComponent } from './admin-container/admin-user-role-edit/admin-user-role-edit.component';
import { CreateTicketComponent } from './admin-container/create-ticket/create-ticket.component';
import { TicketViewComponent } from './admin-container/ticket-view/ticket-view.component';
import { TicketsListComponent } from './admin-container/tickets-list/tickets-list.component';
import { ApiIntegrationCreateComponent } from './admin-container/api-integration-create/api-integration-create.component';
import { ApiViewComponent } from './admin-container/api-view/api-view.component';
import { ApiEditComponent } from './admin-container/api-edit/api-edit.component';
import { ProcessNdrComponent } from './admin-container/process-ndr/process-ndr.component';
import { ReturnToOrderComponent } from './admin-container/return-to-order/return-to-order.component';
import { RefundsComponent } from './admin-container/refunds/refunds.component';
import { DiscrepancyComponent } from './admin-container/discrepancy/discrepancy.component';
import { FreezeComponent } from './admin-container/freeze/freeze.component';
import { PackagingComponent } from './admin-container/packaging/packaging.component';
import { ToolCostEstimationComponent } from './admin-container/tool-cost-estimation/tool-cost-estimation.component';
import { CustomercareOrdersComponent } from './admin-container/customercare-orders/customercare-orders.component';
import { NDRSummaryComponent } from './admin-container/ndr-summary/ndr-summary.component';
import { WalletComponent } from './admin-container/wallet/wallet.component';

//import { NgQrScannerModule } from 'ngx-qr';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
//import { ZXingScannerModule } from './admin-container/scan-code/public-api';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Camera } from '@ionic-native/camera/ngx';
import { CodDataComponent } from './admin-container/cod-data/cod-data.component';
import { SellerProductsListComponent } from './admin-container/seller-products-list/seller-products-list.component';
import { SellerProductsCreateComponent } from './admin-container/seller-products-create/seller-products-create.component';
import { SellerProductsViewComponent } from './admin-container/seller-products-view/seller-products-view.component';
import { SellerProductsEditComponent } from './admin-container/seller-products-edit/seller-products-edit.component';
import { SellerReturnsListComponent } from './admin-container/seller-returns-list/seller-returns-list.component';
import { SellerReportsComponent } from './admin-container/seller-reports/seller-reports.component';
import { SellerSettingsComponent } from './admin-container/seller-settings/seller-settings.component';
import { ReturnProcessOrderComponent } from './admin-container/return-process-order/return-process-order.component';
import { ReassignShipmentComponent } from './admin-container/reassign-shipment/reassign-shipment.component';
import { DatePipe } from '@angular/common';
import { CreditsProcessingComponent } from './admin-container/credits-processing/credits-processing.component';
import { CreditsReportsComponent } from './admin-container/credits-reports/credits-reports.component';
import { UpdateOrderStatusComponent } from './admin-container/update-order-status/update-order-status.component';
import { ShipmentExceptionReportsComponent } from './admin-container/shipment-exception-reports/shipment-exception-reports.component';
import { DateAgoPipe } from './date-ago.pipe';
import { ServiceWorkerModule } from '@angular/service-worker';
import { User } from './_models/user';


@NgModule({
    imports: [
        /*     AgmCoreModule.forRoot({
              apiKey: 'AIzaSyDn2DT3PbIe5FCmGl1msOUol2R9qHjSEcc',
              libraries: ['places']
            }), */
        ReactiveFormsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        HttpClientModule,
        QRCodeModule,
        FormsModule,
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        DataTablesModule,
        NgSelectModule,
        ClipboardModule,
        // NgQrScannerModule,
        PDFExportModule,
        NgMultiSelectDropDownModule.forRoot(),
        ToastrModule.forRoot({
            maxOpened: 4,
            autoDismiss: true,
            timeOut: 9000,
            preventDuplicates: true
        }),
        ToastContainerModule,
        BrowserAnimationsModule,
        NgxSpinnerModule,
        //HighchartsChartModule,
        NgxBarcode6Module,
        MatDialogModule,
        MatListModule,
        MatTooltipModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatMenuModule,
        MatIconModule,
        ZXingScannerModule,
        NgbModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: !isDevMode(),
          // Register the ServiceWorker as soon as the application is stable
          // or after 30 seconds (whichever comes first).
          registrationStrategy: 'registerWhenStable:30000'
        }),
    ],
    declarations: [
        AppComponent,
        CODOrdersComponent,
        HomeComponent,
        TrackOutboundOrderComponent,
        TrackingOutBoundOrderComponent,
        TrackReturnOrderComponent,
        DashboardComponent,
        InvoicesComponent,
        CreditsProcessingComponent,
        CreditsReportsComponent,
        UpdateOrderStatusComponent,
        InventoriesComponent,
        TrackInboundOrderComponent,
        TrackOutBoundOrdersComponent,
        LoginComponent, TrackOrderComponent,
        SecurityTypesComponent,
        CreateToteComponent,
        CreateRoleComponent,
        ToteListComponent,
        HeaderComponent,
        FooterComponent,
        OrdersComponent,
        ViewAccountOwnerComponent,
        FlipkartAuthComponent,
        SplitOrderComponent,
        InvoiceCreateComponent,
        PaymentsComponent,
        PickrrCreateComponent,
        CreateTicketComponent,
        TicketViewComponent,
        TicketsListComponent,
        ApiIntegrationCreateComponent,
        ApiViewComponent,
        ApiEditComponent,
        ProcessNdrComponent,
        ReturnToOrderComponent,
        RefundsComponent,
        DiscrepancyComponent,
        FreezeComponent,
        PackagingComponent,
        ToolCostEstimationComponent,
        CustomercareOrdersComponent,
        NDRSummaryComponent,
        WalletComponent,
        WefastCreateComponent,
        ShippigoCreateComponent,
        ShipyaariCreateComponent,
        VamashipCreateComponent,
        AdminManageShiftDeliveryComponent,
        AdminManageShiftBlueDartComponent,
        AdminManageShadowFaxComponent,
        AdminUserViewComponent,
        AdminUserRoleEditComponent,
        SecurityComponent,
        PrestaShopUserCreateComponent,
        PrestaShopStoreManagementComponent,
        PrintLayoutComponent,
        Registration1Component,
        AuthenticateComponent,
        AuthorizeComponent,
        SnapDealCreateComponent,
        SnapdealManageStoreManagementComponent,
        RzrPmtRespComponent,
        ZohoCommerceUserComponent,
        StoreHippoCreateComponent,
        ScheduledJobsConfigurationComponent,
        StoreHippoManageComponent,
        ManageGoogleSheetComponent,
        DunzoCreateComponent,
        AdminManageDelhiveryComponent,
        AdminManageFedexComponent,
        AdminManageDotzotComponent,
        AdminManageGatiComponent,
        AdminManageDunzoComponent,
        AdminManageWefastComponent,
        AdminManagePickrrComponent,
        AdminManageShippigoComponent,
        AdminManageShipyaariComponent,
        AdminManageVamashipComponent,
        DotzotManageComponent,
        WefastManageComponent,
        ShiftDeliveryManageComponent,
        BlueDartManageComponent,
        ShadowFaxManageComponent,
        FedexManageComponent,
        DunzoManageComponent,
        GatiManageComponent,
        VamashipManageComponent,
        PickrrManageComponent,
        ShipyaariManageComponent,
        ShippigoManageComponent,
        DelhiveryManageComponent,
        AdminConfigurationComponent,
        AdminDunzoCreateComponent,
        AdminPickrrCreateComponent,
        AdminWeFastCreateComponent,
        AdminShipyaariCreateComponent,
        AdminShippigoCreateComponent,
        AdminVamashipCreateComponent,
        ZohoCommerceManageStoreManagementComponent,
        ReportsListComponent,
        ReportsDetailComponent,
        ApiSettingsComponent,
        AdminUserListComponent,
        AdminRolesListComponent,
        AdminReturnsComponent,
        StoreManagementComponent,
        ShipmentViewComponent,
        AdminUserCreateComponent,
        DriverAssignmentComponent,
        PackageConfigurationComponent,
        DriverShipmentsComponent,
        DriverMyAccountComponent,
        DriverDashboardComponent,
        MagentoUserCreateComponent,
        ShopifyUserCreateComponent,
        CreateGoogleSheetComponent,
        AmazonUserCreateComponent,
        ShopcluesUserCreateComponent,
        BigCommerceUserCreateComponent,
        WoocommerceUserCreateComponent,
        OpencartUserCreateComponent,
        FlipkartUserCreateComponent,
        EbayUserCreateComponent,
        ViewDriverComponent,
        ReturnProcessOrderComponent,
        ReassignShipmentComponent,
        ViewReturnOrderComponent,
        ContactsComponent,
        InfoComponent,
        ErrorComponent,
        DriversListComponent,
        ReturnOrderComponent,
        CreateReturnManuallyComponent, SecurityDefaultComponent, Otp2Component, ShipmentExceptionReportsComponent,
        AdminShipmentListComponent, FinanceCODOrdersComponent, FinanceCodOrdersPaymentProcessingComponent,
        EditAddressComponent, HomeListComponent, SellerOrdersListComponent, SellerDashboardComponent, SellerReportsDetailsComponent,
        OtpComponent, CreateAoSellerComponent, ViewAoSellerComponent, EditAoSellerComponent, OrderProcessingComponent,
        AdminReportsComponent, ShiftDeliveryCreateComponent, ShadowFaxCreateComponent, BlueDartCreateComponent, DelhiveryCreateComponent, DotzotCreateComponent,
        AdminReportsDetailComponent, GatiCreateComponent, RapidDeliveryCreateComponent, FedExCreateComponent, AdminGatiCreateComponent, AdminRapidDeliveryCreateComponent, AdminFedExCreateComponent,
        CreateDriverComponent, AdminShiftDeliveryCreateComponent, AdminShadowFaxCreateComponent, AdminBluedartCreateComponent, AdminDelhiveryCreateComponent, AdminDotzotCreateComponent,
        EditDriverComponent, LoginPopupComponent, AdminCarriersComponent, AdminCarrierslistComponent, CarriersListComponent, CustomerCarriersComponent,
        ReplaceStatusPipe, AdminFulfillmentPricingComponent, AdminServicesPricingComponent,
        CreateAddressComponent, ShopifyManageStoreManagementComponent, AmazonManageStoreManagementComponent, ShopcluesManageStoreManagementComponent, BigCommerceManageStoreManagementComponent, WoocommerceManageStoreManagementComponent,
        FlipkartManageStoreManagementComponent, EbayManageStoreManagementComponent, AdminVerifyDocumentsComponent, OpencartManageStoreManagementComponent,
        LoginContainerComponent, MyAccountListComponent, MarketingComponent, TrackingPageMenuComponent, TrackingPageBannerComponent, SellerMarketingComponent, NotificationSettingsComponent, ShipmentListComponent, ShipmentCreateComponent, ViewCustomerComponent,
        PhonePipe, ViewInvoicesComponent, WarehouseViewComponent, SettingsDriversComponent, StoreIntegrationsComponent, AdminDashboardComponent,
        EditNotificationComponent, ProcessingOrderComponent, ViewOrdersComponent, InventoriesViewComponent, AdminStockTransferComponent, StoreConnectionsComponent,
        NotificationListComponent, CreateReturnsComponent, DeliveryChallanComponent, ShippingLabelComponent, AdminSettingsComponent, EditRoleComponent, ProcessingStockTransfersComponent,
        CreateNotificationComponent, WarehouseReceivingOrdersComponent, SettingReturnsComponent, ManageStoreManagementComponent,
        ReportsComponent, ReturnsComponent, CreateOrdersComponent, SummaryOrdersComponent, AdminWalletPaymentComponent,
        AccountOwnerListComponent, ForgotPasswordComponent, AmznAuthComponent, ZohoAuthComponent, ActivationComponent, DunzoWebhookComponent, AdminProductsComponent, ResetPasswordComponent, AdminContainerComponent, WarehouseRequestListComponent,
        AccountOwnerSelectionComponent, CreateInventoryComponent, AddComponentComponent, CreateContactsComponent, EditContactsComponent, EditInventoryComponent,
        AdminInvoicesComponent, AccountOwnerListComponent,
        CreateAccountOwnerListComponent, AdminOrdersComponent, UserAccountComponent, InvoiceSettingsComponent, EditUserAccountComponent, PaymentStatusComponent, PaymentProcessingComponent, PaymentConfirmationComponent,
        EditAccountOwnerListComponent, EditOrderComponent, CreateInvoiceComponent,
        OnlyNumbersDirective, ShippingLabelSettingsComponent, SupportContainerComponent,
        DocumentSummaryComponent, CodDataComponent, SellerProductsListComponent, SellerProductsCreateComponent, SellerProductsViewComponent, SellerProductsEditComponent, SellerReturnsListComponent, SellerSettingsComponent, SellerReportsComponent, WarehouseSettingsDetailsComponent, ScanQrCodeComponent, FormatsDialogComponent, AppInfoComponent, AppInfoDialogComponent, DateAgoPipe
    ],
    providers: [Camera, DatePipe, NgbActiveModal,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        // provider used to create fake backend
        fakeBackendProvider
    ],
    exports: [SettingReturnsComponent, ScanQrCodeComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
